const VisionerLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 140, height: 40 },
    default: { width: 180, height: 50 },
    large: { width: 240, height: 65 },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 240 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="visioner-logo"
    >
      {/* Building/Structure Icon */}
      <g>
        {/* Main Building Shape */}
        <rect x="8" y="18" width="14" height="38" fill="#F97316" />
        <rect x="24" y="12" width="14" height="44" fill="#0F172A" />
        <rect x="40" y="22" width="10" height="34" fill="#10B981" />
        
        {/* Building Windows */}
        <rect x="11" y="24" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="11" y="32" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="11" y="40" width="4" height="4" fill="white" opacity="0.8" />
        
        <rect x="28" y="18" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="28" y="26" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="28" y="34" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="28" y="42" width="4" height="4" fill="white" opacity="0.8" />
        
        <rect x="43" y="28" width="3" height="3" fill="white" opacity="0.8" />
        <rect x="43" y="36" width="3" height="3" fill="white" opacity="0.8" />
        <rect x="43" y="44" width="3" height="3" fill="white" opacity="0.8" />
        
        {/* Foundation Line */}
        <rect x="5" y="56" width="50" height="3" fill="#0F172A" />
      </g>

      {/* Text: VISIONER */}
      <text
        x="65"
        y="40"
        fontFamily="Oswald, sans-serif"
        fontSize="28"
        fontWeight="700"
        fill="#0F172A"
        letterSpacing="-0.02em"
      >
        VISIONER
      </text>

      {/* Text: CONSULTANTS */}
      <text
        x="65"
        y="55"
        fontFamily="Manrope, sans-serif"
        fontSize="11"
        fontWeight="500"
        fill="#64748B"
        letterSpacing="0.15em"
      >
        CONSULTANTS
      </text>
    </svg>
  );
};

// White version for dark backgrounds
export const VisionerLogoWhite = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 140, height: 40 },
    default: { width: 180, height: 50 },
    large: { width: 240, height: 65 },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 240 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="visioner-logo-white"
    >
      {/* Building/Structure Icon */}
      <g>
        <rect x="8" y="18" width="14" height="38" fill="#F97316" />
        <rect x="24" y="12" width="14" height="44" fill="white" />
        <rect x="40" y="22" width="10" height="34" fill="#10B981" />
        
        {/* Building Windows */}
        <rect x="11" y="24" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="11" y="32" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="11" y="40" width="4" height="4" fill="white" opacity="0.8" />
        
        <rect x="28" y="18" width="4" height="4" fill="#0F172A" opacity="0.8" />
        <rect x="28" y="26" width="4" height="4" fill="#0F172A" opacity="0.8" />
        <rect x="28" y="34" width="4" height="4" fill="#0F172A" opacity="0.8" />
        <rect x="28" y="42" width="4" height="4" fill="#0F172A" opacity="0.8" />
        
        <rect x="43" y="28" width="3" height="3" fill="white" opacity="0.8" />
        <rect x="43" y="36" width="3" height="3" fill="white" opacity="0.8" />
        <rect x="43" y="44" width="3" height="3" fill="white" opacity="0.8" />
        
        {/* Foundation Line */}
        <rect x="5" y="56" width="50" height="3" fill="white" />
      </g>

      {/* Text: VISIONER */}
      <text
        x="65"
        y="40"
        fontFamily="Oswald, sans-serif"
        fontSize="28"
        fontWeight="700"
        fill="white"
        letterSpacing="-0.02em"
      >
        VISIONER
      </text>

      {/* Text: CONSULTANTS */}
      <text
        x="65"
        y="55"
        fontFamily="Manrope, sans-serif"
        fontSize="11"
        fontWeight="500"
        fill="#94A3B8"
        letterSpacing="0.15em"
      >
        CONSULTANTS
      </text>
    </svg>
  );
};

// Icon only version
export const VisionerIcon = ({ className = "", size = 48 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="visioner-icon"
    >
      <g>
        <rect x="5" y="15" width="16" height="40" fill="#F97316" />
        <rect x="23" y="8" width="16" height="47" fill="#0F172A" />
        <rect x="41" y="20" width="12" height="35" fill="#10B981" />
        
        {/* Windows */}
        <rect x="9" y="22" width="5" height="5" fill="white" opacity="0.8" />
        <rect x="9" y="32" width="5" height="5" fill="white" opacity="0.8" />
        <rect x="9" y="42" width="5" height="5" fill="white" opacity="0.8" />
        
        <rect x="28" y="15" width="5" height="5" fill="white" opacity="0.8" />
        <rect x="28" y="25" width="5" height="5" fill="white" opacity="0.8" />
        <rect x="28" y="35" width="5" height="5" fill="white" opacity="0.8" />
        <rect x="28" y="45" width="5" height="5" fill="white" opacity="0.8" />
        
        <rect x="45" y="28" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="45" y="38" width="4" height="4" fill="white" opacity="0.8" />
        <rect x="45" y="48" width="4" height="4" fill="white" opacity="0.8" />
        
        {/* Foundation */}
        <rect x="2" y="55" width="56" height="3" fill="#0F172A" />
      </g>
    </svg>
  );
};

export default VisionerLogo;
